import {
  type GDSStyleObject,
  queryHelpers,
  useMediaQuery,
} from "@leagueplatform/genesis-core";
import { Chat } from "@leagueplatform/chat";
import ChatUnavailableIllustration from "assets/chat_unavailable.svg";
import { LiveChatCTA } from "./live-chat-cta.component";
import { chatInstance } from "./chat-instance";

const TERMINAL_STATE = {
  illustration: (
    <img src={ChatUnavailableIllustration} alt="" width={232} height={232} />
  ),
};

/* Emblem's chat header is a filled brand-purple bar with white text and
 * icons (Figma: EmblemHealth Solution Discovery R2, node 7830-34337).
 * The SDK hard-codes a white header with no class or prop hook, but its
 * `css` prop is merged into the `.GDS-modal` styles, so the header row
 * is targeted as the element that directly contains the SDK's
 * `#chat-heading` title. Only the header is restyled.
 *
 * The minimize/close buttons are Genesis quiet secondary buttons, which
 * keep a solid `$secondaryBackgroundDefault` (white) fill. Rather than
 * fight the Button's own state styles, redefine the secondary tokens
 * within the header so its default/hover/pressed states all read
 * correctly on purple. */
const CHAT_CSS: GDSStyleObject = {
  ".GDS-modal-content > div:has(> #chat-heading)": {
    "--GDS-colors-secondaryBackgroundDefault": "transparent",
    "--GDS-colors-secondaryBackgroundHovered":
      "var(--GDS-colors-interactiveActionHovered)",
    "--GDS-colors-secondaryBackgroundPressed":
      "var(--GDS-colors-interactiveActionPressed)",
    "--GDS-colors-secondaryTextDefault": "var(--GDS-colors-primaryTextDefault)",
    "--GDS-colors-secondaryTextHovered": "var(--GDS-colors-primaryTextDefault)",
    background: "$interactiveActionPrimary",
    borderBlockEnd: "none",
    "#chat-heading": {
      color: "$primaryTextDefault",
    },
  },
};

export const LiveChat = () => {
  const isMobile = useMediaQuery(queryHelpers.down("mobileLandscape"));

  return (
    <>
      <LiveChatCTA />
      <Chat
        chatInstance={chatInstance}
        layout={isMobile ? "fullscreen" : "bottomRight"}
        terminalState={TERMINAL_STATE}
        css={CHAT_CSS}
      />
    </>
  );
};
